import React from 'react';
import { SectionLabel } from './ui/SectionLabel';
import { CtaButton } from './ui/CtaButton';
import { InteriorCarousel } from './InteriorCarousel';
const labels = ['Class Intention', 'Duration', 'Level', 'Props', 'Opening', 'Warm-Up', 'Main Sequence', 'Teaching Cues', 'Transitions', 'Modifications', 'Cooldown', 'Closing'];
const stats = [{
  value: '120',
  label: 'Complete classes'
}, {
  value: '6',
  label: 'Professional volumes'
}, {
  value: '20',
  label: 'Classes per volume'
}, {
  value: '40+',
  label: 'Weeks of material*'
}];
export function InsideSystemSection() {
  return <section className="w-full bg-sand py-10 sm:py-14 lg:py-20" aria-labelledby="inside-heading" data-id="element-74" data-mp="irmch3f475nr">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-75" data-mp="dsj5vejhkrdo">
        <div className="mx-auto max-w-2xl text-center" data-id="element-76" data-mp="33imsr9lsjn4e">
          <div className="flex justify-center" data-id="element-77" data-mp="33k69107g5y66">
            <SectionLabel data-id="element-78" data-mp="2yja6apyu0i2c">Inside the system</SectionLabel>
          </div>
          <h2 id="inside-heading" className="mt-3 font-serif text-[1.6rem] font-semibold uppercase leading-[1.08] text-ink sm:text-4xl" data-id="element-79" data-mp="2ym4p6d275utn">
            Take a look <span className="text-forest" data-id="element-80" data-mp="20fdas8p2dbf1">inside.</span>
          </h2>
          <p className="mx-auto mt-3 max-w-lg text-[0.9rem] leading-snug text-muted sm:text-lg" data-id="element-81" data-mp="1ljdsk588puw6">
            These are real pages from the Yoga Teacher System™ — complete Ready-to-Teach classes
            designed so you can open, choose and teach.
          </p>
        </div>

        <InteriorCarousel data-id="element-82" data-mp="1hitwl4zekxbm" />

        <p className="mt-5 text-center font-serif text-[1rem] font-semibold uppercase leading-tight text-ink sm:text-xl" data-id="element-83" data-mp="1hk4zz3oxs327">
          Real pages. Complete classes. Ready to teach.
        </p>

        <ul className="mt-5 grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4" data-id="element-84" data-mp="17tk3pmwqjamg">
          {labels.map(label => <li key={label} className="rounded-xl border border-sandDark bg-ivory px-3 py-2.5 text-center text-[0.65rem] font-semibold uppercase leading-tight tracking-label text-ink sm:text-[0.7rem]" data-id="element-85" data-mp="ttstzyd94ge9">
              {label}
            </li>)}
        </ul>

        <ul className="mt-6 grid grid-cols-2 gap-2.5 sm:grid-cols-4" data-id="element-86" data-mp="2vogizfl20y5c">
          {stats.map(({
          value,
          label
        }) => <li key={label} className="rounded-2xl border border-gold/30 bg-ivory px-3 py-4 text-center" data-id="element-87" data-mp="2lsdjkhhl7dm3">
              <p className="font-serif text-3xl font-semibold leading-none text-forest sm:text-4xl" data-id="element-88" data-mp="3jet0ni63q994">
                {value}
              </p>
              <p className="mt-1.5 text-[0.58rem] font-semibold uppercase tracking-label text-muted" data-id="element-89" data-mp="3ef82vb2o46xz">
                {label}
              </p>
            </li>)}
        </ul>

        <p className="mt-3 text-center text-[0.6rem] leading-relaxed text-muted" data-id="element-90" data-mp="35ifis7xno5u4">
          *Based on teaching approximately 3 classes per week.
        </p>

        <p className="mx-auto mt-5 max-w-xl text-center font-serif text-[1rem] font-semibold uppercase leading-tight text-forest sm:text-xl" data-id="element-91" data-mp="1u0xvsk4ankua">
          Months of teaching material without starting every class from zero.
        </p>

        <div className="mt-6" data-id="element-92" data-mp="dl0aktrb0oet">
          <CtaButton label="Get instant access" microcopy="One-Time Purchase • No Subscription • Instant Access" data-id="element-93" data-mp="ijtp8pibulgk" />
        </div>
      </div>
    </section>;
}